import { createFileRoute } from '@tanstack/react-router';
import FoodManagement from '../../components/manager/FoodManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/food')({
  component: FoodManagementRoute,
});

function FoodManagementRoute() {
  return (
    <ManagerPortal>
      <FoodManagement />
    </ManagerPortal>
  );
}
